<script setup>

const agendaShardPng = '/img/2026/agenda-overview-desktop-top-shard.png';

const props = defineProps({
    headline: {
        type: String,
        required: false,
        default: 'Headline',
    },
    copy: {
        type: String,
        required: false,
        default: false,
    },
    items: {
        type: Array,
        required: false,
        default: [],
    }
});

</script>
<template>
    <div class="agenda relative overflow-hidden text-white py-[43px] lg:py-[75px]"
        style="background: linear-gradient(215deg, var(--orange, #D63D00) 10%, var(--orange, #D63D00) 53%, var(--purple, #820CA7) 103%)">
        <img :src="agendaShardPng" loading="lazy" decoding="async" alt="" aria-hidden="true"
            class="hidden lg:display-block absolute top-0 right-0 pointer-events-none z-[0]" />
        <div class="relative z-[1] px-(--box-padding-lr-m) lg:px-(--box-padding-lr)">
            <MessHtml :html="headline" tag="h2" class="font-hubspot-serif font-normal text-[calc(42/var(--base-fs)*1rem)] leading-[1.1] tracking-normal lg:text-[calc(60/var(--base-fs)*1rem)] text-white mb-8" />
            <ul class="agenda-list text-white">
                <li v-for="(item, index) in items" :key="index" class="agenda-item flex flex-col items-start py-6 lg:flex-row lg:items-start lg:gap-[13.125rem] lg:py-14">
                    <div class="header lg:w-[19.375rem] lg:shrink-0">
                        <MessHtml v-if="item.headline" :html="item.headline" tag="h3" class="font-hubspot-serif text-[calc(36/var(--base-fs)*1rem)] leading-[1.2] tracking-normal font-normal mb-2" />
                        <MessHtml v-if="item.subHead" :html="item.subHead" tag="h4" class="font-hubspot-sans text-[0.8125rem] leading-[1.125rem] tracking-[0.040625rem] uppercase font-medium mb-4" />
                    </div>
                    <MessHtml v-if="item.copy" :html="item.copy" tag="div" class="copy font-hubspot-sans text-base leading-[26px] tracking-[0.32px] font-light shrink" />
                </li>
            </ul>
        </div>
    </div>
</template>

<style>
.agenda .agenda-list li:first-child {
    border-top: 1px solid rgba(255, 255, 255, 0.3);
}

.agenda .agenda-list li:not(:last-child) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

@media (min-width: 1024px) {
    .agenda .agenda-list li:first-child {
        border-top: none;
    }
}

.agenda .copy strong,
.agenda .copy b {
    font-weight: 500;
}
</style>
